import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import currencyFormatter from "currency-formatter";
import moment from "moment";

import HelpComponent from "../HelpComponent";
import {Tooltip} from "primereact/tooltip";

const _FM_FolioShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [items, setItems] = useState([]);
  const [reservation, setReservation] = useState({});
  const [loading, setLoading] = useState(false);
  const formatQuantity = (quantity) => {
    const parsedQuantity = Number(quantity);
    return Number.isInteger(parsedQuantity) ? String(parsedQuantity) : parsedQuantity.toFixed(2);
  };


  useEffect(() => {
    if (props.reservationId) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation/" + props.reservationId,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setFormData((prev) => ({
            ...prev,
            reservation_group: Number(response.data.data?.reservation_group?.id),
            customer: null,
            accommodation: Number(
              response.data.data?.accommodation?.id ||
              response.data.data?.berth?.residential_unit?.accommodation?.id ||
              response.data.data?.residential_unit?.accommodation?.id
            ),
          }));
          setReservation(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [props.reservationId]);

  useEffect(() => {
    if (window.App.urlVars().folioId || id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio/" + (window.App.urlVars().folioId ?? id),
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setFormData(response.data.data);
          axios({
            method: 'get',
            url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio-item?search[folio][operator]=%3D&search[folio][value]=" + (window.App.urlVars().folioId ?? id),
            params: {},
            headers: {
              'Authorization': 'Bearer ' + Cookies.get("userToken"),
              "Sys-name": Cookies.get("instanceId"),
              "Preferred-locale": Cookies.get("language")
            }
          })
            .then(response => {
              setItems(response.data.data.items);
              setLoading(false)
            })
            .catch(error => {
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
              setLoading(false)
            })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [window.App.state.rerenderFolioList])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          {reservation && reservation.id ? (
            <h2 className={"p-m-0 p-text-normal"}>
              {t('reservation')} <span className={"p-text-bold"}>
              <span className={"tt-association-code-folio-show-info-" + reservation.id + " p-mr-2"}
                    data-pr-tooltip={reservation.association_code}>
                <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
              </span>
              <Tooltip target={".tt-association-code-folio-show-info-" + reservation.id}/>
              <span className={"p-badge"}
                    style={{
                      fontSize: '1rem',
                      backgroundColor: reservation?.status
                        ? reservation?.status?.toLowerCase() === 'pending'
                          ? '#dddddd'
                          : reservation?.status?.toLowerCase() === 'confirmed'
                            ? '#f1eea5'
                            : reservation?.status?.toLowerCase() === 'cancelled'
                              ? '#f7a2a2'
                              : reservation?.status?.toLowerCase() === 'checked_in'
                                ? '#3ec0e9'
                                : reservation?.status?.toLowerCase() === 'checked_out'
                                  ? '#0abb87'
                                  : reservation?.status?.toLowerCase() === 'no_show'
                                    ? '#8a2be2'
                                    : '#ccc'
                        : undefined,
                      color: reservation?.status
                        ? reservation?.status?.toLowerCase() === 'pending' || reservation?.status?.toLowerCase() === 'confirmed'
                          ? '#5f656b'
                          : reservation?.status?.toLowerCase() === 'no_show'
                            ? '#fff'
                            : undefined
                        : undefined
                    }}>
                {reservation?.association_code?.split(' | ').pop()?.trim()}
              </span>
            </span> {t('folio_form').toLowerCase()}
            </h2>
          ) : (
            <h2 className={"p-m-0"}>
              {formData.label || t('folio_show')}
            </h2>
          )}
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button" aria-label={t('edit')}
                  icon={"pi pi-pencil"}
                  disabled={formData.invoiced}
                  onClick={() => {
                    if (window.location.href.includes('#/folio')) {
                      navigate('/folio/')
                      setTimeout(() => {
                        navigate('/folio/update/' + id)
                      }, 500)
                    }
                    if (window.location.href.includes('#/customer')) {
                      setTimeout(() => {
                        navigate('/customer/' + action + '/' + id + '?update=folio&folioId=' + window.App.urlVars().folioId)
                      }, 500)
                    }
                    if (window.location.href.includes('#/reservation')) {
                      setTimeout(() => {
                        navigate('/reservation/' + action + '/' + id + '?update=folio&folioId=' + window.App.urlVars().folioId)
                      }, 500)
                    }
                    if (window.location.href.includes('#/calendar')) {
                      setTimeout(() => {
                        navigate('/calendar/' + action + '/' + id + '?update=folio&folioId=' + window.App.urlVars().folioId)
                      }, 500)
                    }
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      {reservation && reservation.id && (
        <div className={"p-grid"}>
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('reserved_from')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              {moment.utc(reservation.reserved_from).local().format(t('YYYY-MM-DD HH:mm:ss'))}
            </p>
          </div>
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('reserved_to')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              {moment.utc(reservation.reserved_to).local().format(t('YYYY-MM-DD HH:mm:ss'))}
            </p>
          </div>
        </div>
      )}
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('invoiced')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {formData.invoiced === true ? (
              <>
                <i className={"pi pi-check text-success p-mr-2"}></i>
                {formData.invoiced_at !== null &&
                  <>
                    {moment.utc(formData.invoiced_at).local().format(t('YYYY-MM-DD HH:mm:ss'))}
                  </>
                }
              </>
            ) : (
              <i className={"pi pi-times text-danger"}></i>
            )}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
        <HelpComponent type={"show_box"}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="name">{t('name')}</label>
              <span className="p-d-block p-text-bold">
                {/*<span className={"tooltip-" + formData.id}>*/}
                {/*  <i className={"pi pi-info-circle p-mr-2"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>*/}
                {/*</span>*/}
                {formData.name}
                {/*<Tooltip target={".tooltip-" + formData.id}>*/}
                {/*  {t('folio')}: {formData.id}*/}
                {/*</Tooltip>*/}
              </span>
            </div>
          </div>
        </div>
        <div className={"p-grid"}>
          {formData?.customer &&
            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="customer">{t('customer')}</label>
                <span className="p-d-block p-text-bold">
                  {window.location.href.includes('#/folio') &&
                    <>
                      <i className={"pi pi-window-maximize"}
                         onClick={(e) => {
                           navigate('/folio/' + action + '/' + id + '?update=customer&customerId=' + formData.customer?.id)
                         }}
                      ></i>
                      &nbsp;
                    </>
                  }
                  {formData?.customer?.lastname} {formData?.customer?.firstname}
              </span>
              </div>
            </div>
          }
          {formData?.reservation_group &&
            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="reservation_group">{t('reservation_group')}</label>
                <span className="p-d-block p-text-bold">
                   {window.location.href.includes('#/folio') &&
                     <>
                       <i className={"pi pi-window-maximize"}
                          onClick={(e) => {
                            navigate('/folio/' + action + '/' + id + '?read=reservationGroup&reservationGroupId=' + formData.reservation_group?.id)
                          }}
                       ></i>
                       &nbsp;
                     </>
                   }
                  {formData?.reservation_group?.public_id?.toUpperCase()}
              </span>
              </div>
            </div>
          }
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="accommodation">{t('accommodation')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.accommodation?.name}
              </span>
            </div>
          </div>
          {formData.billing_data &&
            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="billing">{t('billing')}</label>
                <span className="p-d-block p-text-bold">
                  <span className={"p-d-block"}>{formData?.billing_data?.name_or_company_name}</span>
                  <small className={"p-d-block"}>{formData?.billing_data?.vat_number}</small>
                  <small
                    className={"p-d-block"}>{formData?.billing_data?.country?.toUpperCase()} {formData?.billing_data?.zip_code}, {formData?.billing_data?.street_and_number}</small>
              </span>
              </div>
            </div>
          }
        </div>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="net_amount">{t('net_amount')}</label>
              <span className="p-d-block p-text-bold">
                {currencyFormatter.format(
                  formData.net_amount, {
                    precision: t('currency_precision'),
                    symbol: t('currency_symbol'),
                    decimal: t('currency_decimal'),
                    thousand: t('currency_thousand'),
                  }
                )}
                &nbsp; {formData?.currency}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="vat">{t('vat')}</label>
              <span className="p-d-block p-text-bold">
                {currencyFormatter.format(
                  formData.vat_amount, {
                    precision: t('currency_precision'),
                    symbol: t('currency_symbol'),
                    decimal: t('currency_decimal'),
                    thousand: t('currency_thousand'),
                  }
                )}
                &nbsp; {formData?.currency}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="gross_amount">{t('gross_amount')}</label>
              <span className="p-d-block p-text-bold">
                {currencyFormatter.format(
                  formData.gross_amount, {
                    precision: t('currency_precision'),
                    symbol: t('currency_symbol'),
                    decimal: t('currency_decimal'),
                    thousand: t('currency_thousand'),
                  }
                )}
                &nbsp; {formData?.currency}
              </span>
            </div>
          </div>
        </div>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="description">{t('description')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.description}
              </span>
            </div>
          </div>
        </div>
      </Panel>

      {id &&
        <Panel className={"p-mt-3"}>
          <h3 className={"p-mt-0"}>
            {t('folio_items')}
          </h3>
          <table className={"w-100 p-datatable-table table-striped"} cellPadding={0} cellSpacing={0} border={0}>
            <tr>
              <th className={"p-p-2 p-text-left"}>{t('name')}</th>
              <th className={"p-p-2 p-text-right"}>{t('quantity')}</th>
              <th className={"p-p-2 p-text-right"}>{t('net_amount')}</th>
              <th className={"p-p-2 p-text-right"}>{t('vat_percent')}</th>
              <th className={"p-p-2 p-text-right"}>{t('gross_amount')}</th>
              <th className={"p-p-2 p-text-right"}>{t('tot_price')}</th>
            </tr>
            {items && items[0] ? (
              <>
                {items.map((item, index) => {
                  return (
                    <tr>
                      <td>
                        {item?.label &&
                          <span className={"p-d-block"}>
                            {item?.label}
                          </span>
                        }
                        {item?.service?.name &&
                          <span className={"p-d-block"}>
                            {item?.service?.name}
                          </span>
                        }
                      </td>
                      <td className={"p-text-right"}>
                        {formatQuantity(item?.quantity)} {item?.service?.unit || item?.unit}
                      </td>
                      <td className={"p-text-right"}>
                        {currencyFormatter.format(
                          item.unit_net_amount, {
                            precision: t('currency_precision'),
                            symbol: t('currency_symbol'),
                            decimal: t('currency_decimal'),
                            thousand: t('currency_thousand'),
                          }
                        )} {formData?.currency}
                      </td>
                      <td className={"p-text-right"}>
                        {item.vat_percent} %
                        {/*{currencyFormatter.format(*/}
                        {/*  item.vat, {*/}
                        {/*    precision: t('currency_precision'),*/}
                        {/*    symbol: t('currency_symbol'),*/}
                        {/*    decimal: t('currency_decimal'),*/}
                        {/*    thousand: t('currency_thousand'),*/}
                        {/*  }*/}
                        {/*)}*/}
                      </td>
                      <td className={"p-text-right p-text-bold"}>
                        {currencyFormatter.format(
                          item.unit_gross_amount, {
                            precision: t('currency_precision'),
                            symbol: t('currency_symbol'),
                            decimal: t('currency_decimal'),
                            thousand: t('currency_thousand'),
                          }
                        )} {formData?.currency}
                      </td>
                      <td className={"p-text-right p-text-bold"}>
                        {currencyFormatter.format(
                          item.gross_amount, {
                            precision: t('currency_precision'),
                            symbol: t('currency_symbol'),
                            decimal: t('currency_decimal'),
                            thousand: t('currency_thousand'),
                          }
                        )} {formData?.currency}
                      </td>
                    </tr>
                  )
                })}
              </>
            ) : (
              <tr>
                <td colSpan={6}>
                  {t('folio_has_no_items')}
                </td>
              </tr>
            )}
          </table>
        </Panel>
      }

    </>
  )
}
export default withTranslation('common')(_FM_FolioShowComponent);
